import { render, staticRenderFns } from "./InventoryDeleteModal.vue?vue&type=template&id=8e880fa4"
import script from "./InventoryDeleteModal.vue?vue&type=script&lang=ts"
export * from "./InventoryDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports